import { Storage } from '../../enums';
import { ISetAuthLocalStorageProps } from './types';

export const setAuthLocalStorage = (params: ISetAuthLocalStorageProps) => {
  const { access_token, refresh_token, username, classification } = params;

  localStorage.setItem(Storage.ACCESS_TOKEN, access_token);
  localStorage.setItem(Storage.REFRESH_TOKEN, refresh_token);
  if (classification) localStorage.setItem(Storage.CLASSIFICATION, classification);
  if (username) localStorage.setItem(Storage.USERNAME, username);
};

export const clearAuthLocalStorage = () => {
  localStorage.removeItem(Storage.ACCESS_TOKEN);
  localStorage.removeItem(Storage.CLASSIFICATION);
  localStorage.removeItem(Storage.REFRESH_TOKEN);
  localStorage.removeItem(Storage.USERNAME);
};
